import {useSelector} from 'react-redux';
import {useCallback, useMemo} from 'react';
import {buildRefLink} from "@goaffpro/aff-client-commons/functions";

function useRefLink(website){
  const {ref_code, ref_identifiers, referral_link_params} = useSelector(useCallback((state)=>{
    return {
      ref_code: state.settings.ref_code,
      website: state.settings.website,
      ref_identifiers: state.settings.ref_identifiers,
      referral_link_params: state.settings.referral_link_params,
    }
  },[]))
  const link = useMemo(()=>{
    return  buildRefLink(ref_code, website, ref_identifiers, referral_link_params)
  },[ref_code, ref_identifiers, referral_link_params, website])
  return [link]
}
export default useRefLink
